import { INITIAL_FORM_FIELDS, VALIDATIONS, VALIDATION_MSGS } from "../constants/constants";

const { FULL_NAME, MOBILE_NUMBER, COUNTRY, COMPANY_NAME, COMPANY_EMAIL } = INITIAL_FORM_FIELDS;

const validateFullName = (value) => {

  if (!new RegExp(VALIDATIONS.WITHOUT_NUMBERS_SPECIAL_CHARACTERS).test(value)) return VALIDATION_MSGS.WITHOUT_NUMBERS_SPECIAL_CHARACTERS;
  else if (!new RegExp(VALIDATIONS.MIN_LENGTH).test(value)) return VALIDATION_MSGS.MIN_LENGTH;
  else if (!new RegExp(VALIDATIONS.FULL_NAME).test(value)) return VALIDATION_MSGS.FULL_NAME;
  return "";
};
const validateMobileNumber = (value, countryCode) => {
  if (countryCode == "91") {
    if (!VALIDATIONS.MOBILE_NUMBER_INDIA.test(value)) return VALIDATION_MSGS.MOBILE_NUMBER;
    else if (VALIDATIONS.COMMON_NUMBER.test(value)) return VALIDATION_MSGS.MOBILE_NUMBER;
  } else {
    if (!VALIDATIONS.MOBILE_NUMBER_OUTSIDE.test(value)) return VALIDATION_MSGS.MOBILE_NUMBER;
    if (VALIDATIONS.ALL_ZERO.test(value)) return VALIDATION_MSGS.MOBILE_NUMBER;
    else if (VALIDATIONS.COMMON_NUMBER.test(value)) return VALIDATION_MSGS.MOBILE_NUMBER;
  }
  return "";
};
const validateCompanyName = (value) => {
  if (!VALIDATIONS.INVALID_COMPANY_NAME.test(value)) return VALIDATION_MSGS.INVALID_COMPANY_NAME;
  if (!VALIDATIONS.MIN_LENGTH.test(value)) return VALIDATION_MSGS.MIN_LENGTH;
  if (!VALIDATIONS.COMPANY_NAME.test(value)) return VALIDATION_MSGS.COMPANY_NAME;
  return "";
};
const validateCompanyEmail = (value) => {
  if (VALIDATIONS.COMMON_DOMAIN_EXCLUDE.test(value)) return VALIDATION_MSGS.DOMAIN_ERROR_MESSAGE;
  if (!VALIDATIONS.COMPANY_EMAIL.test(value)) return VALIDATION_MSGS.COMPANY_EMAIL;
  return "";
};

export const validateInput = (field, formData) => {
  let { name, value, required } = field;
  const { country } = formData;
  let error = "";
  value = value.trim();
  if (required && (!value || value.length == 0)) {
    error = VALIDATION_MSGS.REQUIRED;
    return error;
  }
  switch (name) {
    case FULL_NAME:
      return validateFullName(value);
    case MOBILE_NUMBER:
      return validateMobileNumber(value, country.value.phone);
    case COMPANY_NAME:
      return validateCompanyName(value);
    case COMPANY_EMAIL:
      return validateCompanyEmail(value);
    default:
      return error;
  }
};
